import inputTypes from "../inputTypes";

const { MELEE_WEAPON } = inputTypes;

export default {
  RUSTY_SWORD: {
    INTERNAL_ID: "STARTSWORD",
    TYPE: MELEE_WEAPON,
    NAME: "Rusty Sword",
  },
  BALANCED_BLADE: {
    INTERNAL_ID: "QUICKSWORD",
    TYPE: MELEE_WEAPON,
    NAME: "Balanced Blade",
  },
  TWIN_DAGGERS: {
    INTERNAL_ID: "DUALDAGGERS",
    TYPE: MELEE_WEAPON,
    NAME: "Twin Daggers",
  },
  NUTCRACKER: {
    INTERNAL_ID: "STUNMACE",
    TYPE: MELEE_WEAPON,
    NAME: "Nutcracker",
  },
  BLOOD_SWORD: {
    INTERNAL_ID: "BLEEDER",
    TYPE: MELEE_WEAPON,
    NAME: "Blood Sword",
  },
  SPARTAN_SANDALS: {
    INTERNAL_ID: "BUMPBOOTS",
    TYPE: MELEE_WEAPON,
    NAME: "Spartan Sandals",
  },
  OILED_SWORD: {
    INTERNAL_ID: "OILSWORD",
    TYPE: MELEE_WEAPON,
    NAME: "Oiled Sword",
  },
  BROADSWORD: {
    INTERNAL_ID: "BROADSWORD",
    TYPE: MELEE_WEAPON,
    NAME: "Broadsword",
  },
  ASSASSINS_DAGGER: {
    INTERNAL_ID: "BACKSTABBER",
    TYPE: MELEE_WEAPON,
    NAME: "Assassin's Dagger",
  },
  FRANTIC_SWORD: {
    INTERNAL_ID: "LOWHEALTH",
    TYPE: MELEE_WEAPON,
    NAME: "Frantic Sword",
  },
  CURSED_SWORD: {
    INTERNAL_ID: "EVILSWORD",
    TYPE: MELEE_WEAPON,
    NAME: "Cursed Sword",
  },
  SHOVEL: {
    INTERNAL_ID: "SHOVEL",
    TYPE: MELEE_WEAPON,
    NAME: "Shovel",
  },
  SPITE_SWORD: {
    INTERNAL_ID: "REVENGESWORD",
    TYPE: MELEE_WEAPON,
    NAME: "Spite Sword",
  },
  VALMONTS_WHIP: {
    INTERNAL_ID: "WHIP",
    TYPE: MELEE_WEAPON,
    NAME: "Valmont's Whip",
  },
  WRENCHING_WHIP: {
    INTERNAL_ID: "HOOKWHIP",
    TYPE: MELEE_WEAPON,
    NAME: "Wrenching Whip",
  },
  IMPALER: {
    INTERNAL_ID: "IMPALESPEAR",
    TYPE: MELEE_WEAPON,
    NAME: "Impaler",
  },
  SADISTS_STILETTO: {
    INTERNAL_ID: "BLEEDCRIT",
    TYPE: MELEE_WEAPON,
    NAME: "Sadist's Stiletto",
  },
  WAR_SPEAR: {
    INTERNAL_ID: "SPEAR",
    TYPE: MELEE_WEAPON,
    NAME: "War Spear",
  },
  RAPIER: {
    INTERNAL_ID: "RAPIER",
    TYPE: MELEE_WEAPON,
    NAME: "Rapier",
  },
  SPIKED_BOOTS: {
    INTERNAL_ID: "SPIKEDBOOTS",
    TYPE: MELEE_WEAPON,
    NAME: "Spiked Boots",
  },
  HAYABUSA_BOOTS: {
    INTERNAL_ID: "MULTIKICKBOOTS",
    TYPE: MELEE_WEAPON,
    NAME: "Hayabusa Boots",
  },
  HAYABUSA_GAUNTLETS: {
    INTERNAL_ID: "QUICKFISTS",
    TYPE: MELEE_WEAPON,
    NAME: "Hayabusa Gauntlets",
  },
  TORCH: {
    INTERNAL_ID: "BURNER",
    TYPE: MELEE_WEAPON,
    NAME: "Torch",
  },
  SYMMETRICAL_LANCE: {
    INTERNAL_ID: "KINGSSPEAR",
    TYPE: MELEE_WEAPON,
    NAME: "Symmetrical Lance",
  },
  SWIFT_SWORD: {
    INTERNAL_ID: "SPEEDBLADE",
    TYPE: MELEE_WEAPON,
    NAME: "Swift Sword",
  },
  MEAT_SKEWER: {
    INTERNAL_ID: "DASHSWORD",
    TYPE: MELEE_WEAPON,
    NAME: "Meat Skewer",
  },
  GIANT_KILLER: {
    INTERNAL_ID: "GIANTKILLER",
    TYPE: MELEE_WEAPON,
    NAME: "Giant Killer",
  },
  SHRAPNEL_AXES: {
    INTERNAL_ID: "BULLETBLADE",
    TYPE: MELEE_WEAPON,
    NAME: "Shrapnel Axes",
  },
  SEISMIC_STRIKE: {
    INTERNAL_ID: "SISMICBLADE",
    TYPE: MELEE_WEAPON,
    NAME: "Seismic Strike",
  },
  FLAWLESS: {
    INTERNAL_ID: "PERFECTHALBERD",
    TYPE: MELEE_WEAPON,
    NAME: "Flawless",
  },
  VORPAN: {
    INTERNAL_ID: "PAN",
    TYPE: MELEE_WEAPON,
    NAME: "Vorpan",
  },
  TENTACLE: {
    INTERNAL_ID: "TENTACLEWHIP",
    TYPE: MELEE_WEAPON,
    NAME: "Tentacle",
  },
  FLINT: {
    INTERNAL_ID: "BEHEMOTHHAMMER",
    TYPE: MELEE_WEAPON,
    NAME: "Flint",
  },
  FLASHING_FANS: {
    INTERNAL_ID: "PARRYBLADE",
    TYPE: MELEE_WEAPON,
    NAME: "Flashing Fans",
  },
  LEFT_SCYTHE_CLAW: {
    INTERNAL_ID: "TICKSCYTHELEFT",
    TYPE: MELEE_WEAPON,
    NAME: "Left Scythe Claw",
  },
  RIGHT_SCYTHE_CLAW: {
    INTERNAL_ID: "TICKSCYTHERIGHT",
    TYPE: MELEE_WEAPON,
    NAME: "Right Scythe Claw",
  },
  RHYTHM_N_BOUZOUKI: {
    INTERNAL_ID: "RHYTHMICBLADE",
    TYPE: MELEE_WEAPON,
    NAME: "Rhythm n' Bouzouki",
  },
  CROWBAR: {
    INTERNAL_ID: "CROWBAR",
    TYPE: MELEE_WEAPON,
    NAME: "Crowbar",
  },
  KATANA: {
    INTERNAL_ID: "KATANA",
    TYPE: MELEE_WEAPON,
    NAME: "Katana",
  },

  // ----------------------------- FATAL FALLS ------------------------------ //
  SNAKE_FANG: {
    INTERNAL_ID: "SNAKEFANG",
    TYPE: MELEE_WEAPON,
    NAME: "Snake Fang",
  },
  IRON_STAFF: {
    INTERNAL_ID: "GIANTSTAFF",
    TYPE: MELEE_WEAPON,
    NAME: "Iron Staff",
  },
  LANTERN: {
    INTERNAL_ID: "LANTERN",
    TYPE: MELEE_WEAPON,
    NAME: "Lantern",
    HAS_OFFHAND: true, // TODO: Make this work :)
  },
  LANTERN_OFFHAND: {
    INTERNAL_ID: "LANTERNOFFHAND",
    TYPE: MELEE_WEAPON,
    NAME: "Lantern (Offhand)",
  },
  SERENADE_MELEE: {
    INTERNAL_ID: "NOTFLYINGSWORD",
    TYPE: MELEE_WEAPON,
    NAME: "Serenade (Melee version)",
  },

  // ---------------------------- WHACK A MOLE ------------------------------ //
  TOMBSTONE: {
    INTERNAL_ID: "TOMBSTONE",
    TYPE: MELEE_WEAPON,
    NAME: "Tombstone",
  },
  HEAVY_AXE: {
    INTERNAL_ID: "HEAVYAXE",
    TYPE: MELEE_WEAPON,
    NAME: "Oven Axe",
  },
  CLUB: {
    INTERNAL_ID: "CLUB",
    TYPE: MELEE_WEAPON,
    NAME: "Toothpick",
  },
  CLUB_BROKEN: {
    INTERNAL_ID: "CLUBBROKEN",
    TYPE: MELEE_WEAPON,
    NAME: "Broken Toothpick",
  },

  // -------------------------- EVERYONE IS HERE ---------------------------- //
  MACHETE_PISTOL: {
    INTERNAL_ID: "MACHETEPISTOL",
    TYPE: MELEE_WEAPON,
    NAME: "Machete and Pistol",
  },
  HARD_LIGHT_SWORD: {
    INTERNAL_ID: "HARDLIGHTSWORD",
    TYPE: MELEE_WEAPON,
    NAME: "Hard Light Sword",
  },
  PURE_NAIL: {
    INTERNAL_ID: "PURENAIL",
    TYPE: MELEE_WEAPON,
    NAME: "Pure Nail",
  },
  BONE: {
    INTERNAL_ID: "SKULBONE",
    TYPE: MELEE_WEAPON,
    NAME: "Bone",
  },

  // ------------------------- QUEEN AND THE SEA ---------------------------- //
  TRIDENT: {
    INTERNAL_ID: "TRIDENT",
    TYPE: MELEE_WEAPON,
    NAME: "Trident",
  },
  HANDHOOK: {
    INTERNAL_ID: "HANDHOOK",
    TYPE: MELEE_WEAPON,
    NAME: "Hand Hook",
  },
  SHARK: {
    INTERNAL_ID: "SHARK",
    TYPE: MELEE_WEAPON,
    NAME: "Maw of the Deep",
  },
  ELBOW_BLADES: {
    INTERNAL_ID: "ELBOWBLADES",
    TYPE: MELEE_WEAPON,
    NAME: "Bladed Tonfas",
  },
  WRECKINGBALL: {
    INTERNAL_ID: "WRECKINGBALL",
    TYPE: MELEE_WEAPON,
    NAME: "Wrecking Ball",
  },
  QUEENRAPIER: {
    INTERNAL_ID: "QUEENRAPIER",
    TYPE: MELEE_WEAPON,
    NAME: "Queen's Rapier",
  },

  // ------------------------------ THE BANK -------------------------------- //
  DAGGERPROFIT: {
    INTERNAL_ID: "CUPIDITYDAGGER",
    TYPE: MELEE_WEAPON,
    NAME: "Dagger of Profit",
  },
  GOLDDIGGER: {
    INTERNAL_ID: "GOLDDIGGER",
    TYPE: MELEE_WEAPON,
    NAME: "Gold Digger",
  },
  GOLDDAGGEREVO: {
    INTERNAL_ID: "GOLDDIGGEREVOLVED",
    TYPE: MELEE_WEAPON,
    NAME: "Gold Digger (Evolved)",
  },

  // -------------------------- ENTER THE PANCHAKU -------------------------- //
  NUNCHUCKPAN: {
    INTERNAL_ID: "NUNCHUCKPAN",
    TYPE: MELEE_WEAPON,
    NAME: "Panchaku",
  },

  // -------------------------- EVERYONE IS HERE 2 -------------------------- //
  KINGSCEPTER: {
    INTERNAL_ID: "KINGSCEPTER",
    TYPE: MELEE_WEAPON,
    NAME: "King Scepter",
  },
  BASEBALLBAT: {
    INTERNAL_ID: "BASEBALLBAT",
    TYPE: MELEE_WEAPON,
    NAME: "Baseball Bat",
  },
  STARFURY: {
    INTERNAL_ID: "STARFURY",
    TYPE: MELEE_WEAPON,
    NAME: "Starfury",
  },

  // ------------------------ RETURN TO CASTLEVANIA ------------------------- //
  VAMPIREKILLER: {
    INTERNAL_ID: "VAMPIREKILLER",
    TYPE: MELEE_WEAPON,
    NAME: "Vampire Killer",
  },
  BIBLE: {
    INTERNAL_ID: "BIBLE",
    TYPE: MELEE_WEAPON,
    NAME: "Bible",
  },
  TPSWORD: {
    INTERNAL_ID: "TPSWORD",
    TYPE: MELEE_WEAPON,
    NAME: "Alucard's Sword",
  },
  DEATHSSCYTHE: {
    INTERNAL_ID: "ADELESCYTHE",
    TYPE: MELEE_WEAPON,
    NAME: "Death's Scythe",
  },
  MORNINGSTAR: {
    INTERNAL_ID: "WIGGLEWHIP",
    TYPE: MELEE_WEAPON,
    NAME: "Morning Star",
  },
  WHIPSWORDSHORT: {
    INTERNAL_ID: "SNAKESWORDWEAPON",
    TYPE: MELEE_WEAPON,
    NAME: "Whip Sword (Short Range)",
  },
  WHIPSWORDLONG: {
    INTERNAL_ID: "SNAKESWORDWEAPONALT",
    TYPE: MELEE_WEAPON,
    NAME: "Whip Sword (Long Range)",
  },
  WHIPSWORDSWAP: {
    INTERNAL_ID: "SNAKESWORDSWAP",
    TYPE: MELEE_WEAPON,
    NAME: "Whip Sword (Swap)",
  },

  // ------------------------------ CLEAN CUT ------------------------------- //
  SCISSOR: {
    INTERNAL_ID: "SCISSOR",
    TYPE: MELEE_WEAPON,
    NAME: "Sewing Scissors",
  },

  COMB: {
    INTERNAL_ID: "COMB",
    TYPE: MELEE_WEAPON,
    NAME: "Giant Comb",
  },
};
